import { render, staticRenderFns } from "./manage-access-pos-requests-filter.vue?vue&type=template&id=57fb54b4"
import script from "./manage-access-pos-requests-filter.vue?vue&type=script&lang=js"
export * from "./manage-access-pos-requests-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports